import { createRouter, createWebHistory } from "vue-router";
import routes from "../routes";
import { Routes } from "../types/enums/routes.enum";
import { isLoggined } from "../helpers/session.helper";
import { isPublicBookingRoute } from "../helpers/route-guards.helper";

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Runs before the target route's components mount - this is what actually
// keeps an unauthenticated visit to /ad/ (e.g. the installed PWA's
// start_url, opened while logged out) from ever rendering the owner
// dashboard shell. Previously this check only happened in App.vue's
// onMounted, which runs AFTER the matched route's children have already
// mounted and fired their own authenticated API calls - that's what made
// the installed PWA appear broken/blank for a logged-out user instead of
// cleanly showing the login screen.
router.beforeEach(async (to) => {
  if (isPublicBookingRoute(to.path)) {
    return true;
  }

  const loggedIn = await isLoggined();

  if (to.path.startsWith(Routes.Admin)) {
    return loggedIn ? true : Routes.Main;
  }

  if (loggedIn && (to.path === Routes.Main || to.path === Routes.Login || to.path === Routes.SignUp)) {
    return Routes.Admin;
  }

  return true;
});
